import request from "../../../utils/request";

function authorizeEmail(data) {
  return request({
    url: '/legal-person-enrollment/declaring-person/authorize',
    method: 'POST',
    data
  });
}

const Authorize = {
  authorizeEmail
};

export default Authorize;
